class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const line = this.dataset.index;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 }),
      })
        .then((res) => res.json())
        .then(() => {
          // 💾 Zabeleži da treba da se otvori drawer posle reloada
          localStorage.setItem('openCartDrawerAfterReload', 'true');
          // 🔁 Osveži stranicu
          location.reload();
        })
        .catch((err) => {
          console.error('Remove failed:', err);
          localStorage.setItem('openCartDrawerAfterReload', 'true');
          location.reload();
        });
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

// 💡 Kada se stranica ponovo učita, proveri flag i otvori drawer
document.addEventListener('DOMContentLoaded', () => {
  const shouldOpen = localStorage.getItem('openCartDrawerAfterReload');
  if (shouldOpen === 'true') {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }
    localStorage.removeItem('openCartDrawerAfterReload');
  }
});
